'use strict';

angular.module('clientDashboardApp').directive('locationSummary', function (locationService) {
    return {
        restrict: 'A',
        scope: {
            locationId: '='
        },
        template: '<span uib-tooltip="{{fullSummary}}"><strong>{{businessName}}</strong>{{shortSummary}}</span>',
        link: function (scope, elem, attrs, ctrl) {
            var summary = function (location) {
                var address = location.businessAddress;

                var fullSummary = location.businessName;
                var shortSummary = '';
                if (address.street) fullSummary += ', ' + address.street;
                if (address.suite) fullSummary += ', ' + address.suite;
                if (address.city) {
                    fullSummary += ', ' + address.city;
                    shortSummary += ', ' + address.city;
                }
                if (address.state) {
                    fullSummary += ', ' + address.state;
                    shortSummary += ', ' + address.state;
                }
                if (address.postalCode) fullSummary += ' ' + address.postalCode;
                if (address.country) fullSummary += ', ' + address.country;

                scope.businessName = location.businessName;
                scope.shortSummary = shortSummary;
                scope.fullSummary = fullSummary;
            };
            locationService.getLocation(scope.locationId, false).then(function (location) {
                summary(location);
            });
        }
    }
});
